import React, { useState } from "react";
import * as Yup from "yup";
import IconButton from "@mui/material/IconButton";
import { FormControl, FormGroup, Input, InputLabel, OutlinedInput, TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AuthBoxHeader from "../../components/authentication/AuthBoxHeader";
import AuthLayout from "src/layouts/AuthLayout";
import { Form, FormikProvider, useFormik } from "formik";
import authStores from "../../contexts/AuthProvider";
import { NavLink, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { AUTH_API_URL } from "src/api/axios";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import { LoadingButton } from '@mui/lab';

const Login = () => {
  const authStore = authStores();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const axiosPrivate = useAxiosPrivate();
  const [buttonLoading, setButtonLoding] = useState(false);

  const [passwordInput, setPasswordInput] = useState({
    password: "",
    showPassword: false,
  });
  // Password Input Functionality
  const handleChange = (prop) => (event) => {
    setPasswordInput({ ...passwordInput, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setPasswordInput({
      ...passwordInput,
      showPassword: !passwordInput.showPassword,
    });
  };

  var firebaseConfig = {
    apiKey: "AIzaSyB-b6v29oV03IADlRSQGryNDb1AzZFDsXA",
    authDomain: "binox-bargains.firebaseapp.com",
    projectId: "binox-bargains",
    storageBucket: "binox-bargains.appspot.com",
    messagingSenderId: "502081633964",
    appId: "1:502081633964:web:6e5b42698242f7e390a909",
    measurementId: "G-2EZFZ1C0N3",
  };

  const LoginByMailSchema = Yup.object().shape({
    email: Yup.string().email("Please enter valid email address!").required("email is required"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      // phone: "",
      email: "",
      password: "",
      remember: true,
    },
    validationSchema: LoginByMailSchema,
    onSubmit: async (values, { resetForm }) => {
      const loginObj = {
        email: values.email,
        password: values.password,
        // device: 3,
        // pushToken: "test",
      };
      setButtonLoding(true);
      const [success, error] = await authStore.login(loginObj);
      const userData = {
        userId: { 2: values.email },
        userEmail: values.email,
        verify: "signUp",
      };
      const twoFactorAuth = {
        userId: { 2: values.email },
        userEmail: values.email,
        reason: "twoFactorAuthentication",
      };
      if (success) {
        if (success.isVerify === 0) {
          setButtonLoding(false);
          enqueueSnackbar("user is not verify", {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
          navigate("/otp-verification", { state: userData });
        } else {
          if (typeof window !== "undefined" && "serviceWorker" in navigator) {
            const firebaseApp = initializeApp(firebaseConfig);
            const messaging = getMessaging(firebaseApp);
            // Notification
            getToken(messaging, { vapidKey: "BGkpFn9kySW6eSs40IPfj22_RmuYrF9FxZosXKH1HBFwkplVuNu46mMr2Mjm7T-N3UjcteRVK7GhgcQ60p-FEb0" })
              .then(async (currentToken) => {
                if (currentToken) {
                  // console.log('current token for client: ', currentToken);
                  return await axiosPrivate.post(AUTH_API_URL.updatePushTokenNotification, { pushToken: currentToken });
                } else {
                  console.log("No registration token available. Request permission to generate one.");
                }
              })
              .catch((err) => {
                console.log("An error occurred while retrieving token. ", err);
              });
          }

          setButtonLoding(false);
          resetForm();
          enqueueSnackbar("login successfully.", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
          navigate("/dashboard/");
        }
      } else {
        setButtonLoding(false);
        if (error === "Vendor is not varified!") {
          navigate("/otp-verification", { state: userData });
          enqueueSnackbar(error, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
        } else if (error === "check your email for otp.") {
          navigate("/otp-verification", { state: twoFactorAuth });
          enqueueSnackbar("please Check your email for otp", {
            variant: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 1000,
          });
        } else {
          enqueueSnackbar(error, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            autoHideDuration: 2000,
          });
        }
      }
    },
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;
  return (
    <>
      <AuthLayout title="You can access your partner control panel with your credential.">
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <div className="auth_box">
              <AuthBoxHeader title={"Log in To Continue!"} />
              <FormControl className="form-control-custom" sx={{
                marginBottom: "16px", "&.form-control-custom .MuiFormLabel-root": {
                  position: "unset",
                  transform: "unset",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#333230",
                  marginBottom: "6px"
                }
              }}>
                <InputLabel htmlFor="my-input">Email</InputLabel>
                <TextField
                  placeholder="Email Address"
                  hiddenLabel
                  id="inputEmail"
                  type="email" fullWidth
                  variant="outlined"
                  margin="normal"
                  sx={{
                    "&.MuiTextField-root": {
                      margin: "0px !Important",
                      "& .MuiFormHelperText-root": {
                        marginLeft: "0px !important",
                        marginRight: "0px !important"
                      },
                      "& .MuiInputBase-root": {
                        padding: "14px 24px",
                        border: "1px solid #BDBDBD",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        "&.Mui-error": {
                          border: "1px solid #d32f2f",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px",
                          background: "none",
                          borderRadius: "0px",
                          fontSize: "14px",
                          fontWeight: "500"
                        },
                      }
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  autoComplete {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
              </FormControl>
              <FormControl className="form-control-custom" sx={{
                "&.form-control-custom .MuiFormLabel-root": {
                  position: "unset",
                  transform: "unset",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#333230",
                  marginBottom: "6px"
                }
              }}>
                <InputLabel htmlFor="my-input">Password</InputLabel>
                <TextField
                  className=""
                  id="outlined-adornment-password"
                  fullWidth
                  type={passwordInput.showPassword ? "text" : "password"}
                  margin="normal"
                  hiddenLabel
                  placeholder="Password"
                  value={passwordInput.password}
                  sx={{
                    "&.MuiTextField-root": {
                      margin: "0px !Important",
                      "& .MuiFormHelperText-root": {
                        marginLeft: "0px !important",
                        marginRight: "0px !important"
                      },
                      "& .MuiInputBase-root": {
                        padding: "14px 24px",
                        border: "1px solid #BDBDBD",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        "&.Mui-error": {
                          border: "1px solid #d32f2f",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px",
                          background: "none",
                          borderRadius: "0px",
                          fontSize: "14px",
                          fontWeight: "500"
                        },
                      }
                    },
                  }}
                  onChange={handleChange("password")}
                  InputLabelProps={{ shrink: true }}
                  {...getFieldProps("password")}
                  autoComplete="current-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton sx={{ "&:hover": { bgcolor: "transparent" } }} disableRipple aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                          {passwordInput.showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                />
              </FormControl>
              <div className="d-flex justify-content-between align-items-center">
                <FormGroup sx={{ flexDirection: "row" }}>{/* <FormControlLabel id='rememberCheck' control={<Checkbox />} className="app_text_gray" label="Remember me" /> */}</FormGroup>
                <NavLink to="/forgot-password" underline="hover" className="app_text_12_semibold text-capitalize text_253D83">
                  Forgot Password ?
                </NavLink>
              </div>
              <LoadingButton
                type='submit'
                fullWidth
                className="mt-5 text-white  app_text_16_semibold app_btn_lg"
                loading={buttonLoading}
                loadingPosition="end"
                variant="contained"
                sx={{
                  backgroundColor: "#FFBD05", boxShadow: "none", borderRadius: "8px", "&:hover": {
                    backgroundColor: "#FFBD05",
                    boxShadow: "none",
                  }
                }}
              >
                Log in
              </LoadingButton>
              <h6 className="text-center mt-4 auth_last_comment">Don’t Have An Account?<a href="/register" className="">Sign Up</a>. </h6>
            </div>
          </Form>
        </FormikProvider>
      </AuthLayout>
    </>
  );
};

export default Login;
